import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import { Autocomplete, TextField } from '@mui/material'

const HSType = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  return (
    <Autocomplete
      value={formValues?.incident?.healthSafetyType}
      onChange={(e, value) =>
        handleChange({
          moduleName: 'incident',
          field: 'healthSafetyType',
          value,
        })
      }
      multiple
      renderInput={(params) => (
        <TextField {...params} label="H&S Incident Type" />
      )}
      options={[
        'Slip/Trip',
        'Equipment Fault',
        'Crowd Control',
        'Weather-related',
        'Assault/Violence',
        'Food Poisoning/Allergy',
        'Lost Child/Person',
        'Structural Failure',
        'Fire/Smoke',
        'Hazardous Material',
        'Traffic/Parking Issue',
        'Environmental Hazard',
        'Animal Involvement',
        'Security Breach',
        'Lighting Issue',
        'Communication Failure',
        'Public Disorder',
        'Lost Property',
        'Other',
      ]}
    />
  )
}

export default HSType
